function _addListenner(eventType, handle, once) {
  if (typeof eventType !== 'string') {
    throw new Error('eventType must be a string');
  }

  if (typeof handle !== 'function') {
    throw new Error('handle must be a function');
  }

  handle.once = !!once;

  if (!(eventType in this.handles)) {
    this.handles[eventType] = [];
  }
  this.handles[eventType].push(handle);
}

class Emitter {
  constructor() {
    this.handles = {};
    this.on = this.on.bind(this);
    this.emit = this.emit.bind(this);
    this.off = this.off.bind(this);
  }
  /**
   * 订阅某个事件
   * @param {string} eventType 事件名称
   * @param {function} handle 事件名称
   */
  on(eventType, handle) {
    _addListenner.call(this, eventType, handle, false);
    return this;
  }
  /**
   * 只监听某事件一次
   * @param {string} eventType 事件名称
   * @param {function} handle 事件名称
   */
  once(eventType, handle) {
    _addListenner.call(this, eventType, handle, true);
    return this;
  }
  /**
   * 触发某个事件
   * @param {string} eventType 事件名称
   */
  emit(eventType) {
    const handleArgs = Array.prototype.slice.call(arguments, 1);
    const handles = this.handles[eventType];
    if (!handles) {
      return;
    }
    for (const handle of handles) {
      handle.apply(this, handleArgs);
      if (handle.once) {
        this.off(eventType, handle);
      }
    }
    return this;
  }
  /**
   * 触发某个事件(带有事件结果, 只能有一个监听，并且回调结果只能有一个，否则不符合规定格式)
   * @param {string} eventType 事件名称
   */
  async emitWithOneResponse(eventType) {
    const handleArgs = Array.prototype.slice.call(arguments, 1);
    const handles = this.handles[eventType];
    // handles 的长度只能为 1
    if (!handles || handles.length > 1) {
      return;
    }
    const handle = handles[0];
    const result = await handle.apply(this, handleArgs);
    if (handle.once) {
      this.off(eventType, handle);
    }
    return result;
  }
  /**
   * 取消对某个事件的监听
   * @param {string} eventType 事件名称
   */
  off(eventType, handle) {
    const handles = this.handles[eventType];
    if (!handles) return this;

    let len = handles.length;
    for (let i = len - 1; i >= 0; i--) {
      if (handle === handles[i]) {
        handles.splice(i, 1);
        if (handles.length === 0) {
          delete this.handles[eventType];
        }
        break;
      }
    }
    return this;
  }
  /**
   * 检查某个事件是否已注册回调
   * @param {string} eventType 事件名称
   */
  has(eventType) {
    const handles = this.handles[eventType];
    return handles && handles.length > 0;
  }
}

export default Emitter;
